export const custom_label_icon = ''
export const initial_label = 'UNREAD,INBOX'
export const initial_labels = {
    UNREAD: {
        id: 'UNREAD',
        iconUrl: 'https://www.gstatic.com/images/icons/material/system/1x/mark_as_unread_white_20dp.png',
        name: 'Unread',
        type: 'system',
    },
    INBOX: {
        id: 'INBOX',
        iconUrl: 'https://www.gstatic.com/images/icons/material/system/1x/inbox_white_20dp.png',
        name: 'Inbox',
        type: 'system',
    },
    SENT: {
        id: 'SENT',
        iconUrl: 'https://www.gstatic.com/images/icons/material/system/1x/send_white_20dp.png',
        name: 'Sent',
        type: 'system',
    },
    IMPORTANT: {
        id: 'IMPORTANT',
        iconUrl: 'https://www.gstatic.com/images/icons/material/system/1x/label_important_white_20dp.png',
        name: 'Important',
        messageListVisibility: 'hide',
        labelListVisibility: 'labelHide',
        type: 'system',
    },
    TRASH: {
        id: 'TRASH',
        iconUrl: 'https://www.gstatic.com/images/icons/material/system/1x/delete_white_20dp.png',
        name: 'Trash',
        messageListVisibility: 'hide',
        labelListVisibility: 'labelHide',
        type: 'system',
    },
    DRAFT: {
        id: 'DRAFT',
        iconUrl: 'https://www.gstatic.com/images/icons/material/system/1x/insert_drive_file_white_20dp.png',
        name: 'Draft',
        type: 'system',
    },
    SPAM: {
        id: 'SPAM',
        iconUrl: 'https://www.gstatic.com/images/icons/material/system/1x/report_white_20dp.png',
        name: 'Spam',
        messageListVisibility: 'hide',
        labelListVisibility: 'labelHide',
        type: 'system',
    },
    STARRED: {
        id: 'STARRED',
        iconUrl: 'https://www.gstatic.com/images/icons/material/system/1x/grade_white_20dp.png',
        name: 'Starred',
        type: 'system',
    },
}
export const initial_navigation_object_key = {
    currentPage: 1,
    nextToken: null,
    pageToken: null,
    previousToken: null,
}
export const initial_pagination = {
    currentPage: 1,
    perPage: 50,
    total: null,
    pageToken: null,
    navigationObject: {
        'initial': {
            currentPage: 1,
            nextToken: null,
            pageToken: null,
            previousToken: null,
        },
    },
}
